import PatientCard from "@/components/practitioner/PatientCard";

const NewPatient: React.FC = () => {
  return (
    <div className="w-full flex justify-center h-full items-center">
      <PatientCard />
    </div>
  );
};

export default NewPatient;
